// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-stacked"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M7 21H11V15.5H7V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M15 21H19V15.5H15V21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M19 21H15M19 21V6H15V21M19 21V15.5H15V21M11 21H7M11 21V10H7V21M11 21V15.5H7V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartStackedIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-stacked',
    ref,
    icon: element,
  },
));

ChartStackedIcon.displayName = 'ChartStackedIcon';

export default ChartStackedIcon;
